import { render, staticRenderFns } from "./DxpServiceProviderConfigurationList.vue?vue&type=template&id=289759b6"
import script from "./DxpServiceProviderConfigurationList.vue?vue&type=script&lang=js"
export * from "./DxpServiceProviderConfigurationList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports